import { parseHash } from "@/utils/searchParams";
import { useSearchParams } from "next/navigation";

export const useIsOperatorLink = () => {
  const searchParams = useSearchParams();
  return parseHash(searchParams).get("operator") === "1";
};
